<template>
  <div class="page-container">
    <van-nav-bar fixed :left-arrow="true" :z-index="10" title="更新默认验证码" @click-left="goableBack()"></van-nav-bar>
    <div class="contain">
      <div class="title-bg">更新默认验证码</div>
      <van-cell-group class="group">
        <van-field class="username" v-model="settingPwd.defaultCode" type="password" maxlength="6" placeholder="请输入6位验证码" border clearable />
        <van-field v-model="settingPwd.confirmDefaultCode" type="password" maxlength="6" placeholder="请再次输入6位验证码确认" border clearable />
      </van-cell-group>
      <van-button class="btn" color="rgb(206, 29, 35)" round type="warning" @click="onNextAction" v-preventReClick="500">确认</van-button>
    </div>
  </div>
</template>
      
      <script>
import * as CustApi from "@/api/cust"

import { CellGroup, Field, Toast } from "vant"
import session from "../../utils/session"
import { mapActions } from "vuex"

export default {
  name: "settingPwd",
  components: {
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Toast.name]: Toast
  },
  data() {
    return {
      settingPwd: {
        defaultCode: "",
        confirmDefaultCode: "",
        custId: "",
      }
    }
  },
  computed: {

  },
  mounted() {
    this.settingPwd.custId = this.userInfo.custAccount.custId
  },
  beforeDestroy() { },
  methods: {
    ...mapActions(["getUserInfo"]),
    onNextAction() {
      if (this.settingPwd.defaultCode.length < 6) {
        this.$toast("请输入6位新验证码")
        return
      }
      if (this.settingPwd.confirmDefaultCode.length < 6) {
        this.$toast("请输入6位确认验证码")
        return
      }
      if (this.settingPwd.defaultCode != this.settingPwd.confirmDefaultCode) {
        this.$toast("两次输入的验证码不一致")
        return
      }
      CustApi.updateDefaultCode(this.settingPwd)
        .then((data) => {
          if (data) {
            this.getUserInfo()
            this.goableBack()
          }
        })
        .catch((e) => {
          this.$toast(e.msg || e.message)
        })
    }
  }
}
</script>
      
      <style lang="less" scoped>
.page-container {
  min-height: calc(100vh - 45px);
  background-color: white;
  overflow: hidden;
}
.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border-width: 0px 0;
}
.title-bg {
  margin: 50px 20px;
  font-size: 20px;
  font-weight: 500;
}
.group {
  margin: 50px 40px;
  .username {
    margin-bottom: 30px;
  }
  .van-field {
    border: 1px solid rgb(208, 211, 213);
    border-radius: 5px;
    font-size: 15px;
  }
}
.btn {
  margin: 0 40px;
  height: 44px;
  width: calc(100vw - 80px);
  border-radius: 22px;
  font-size: 15px;
  font-weight: 500;
}
</style>
      